import React, { ChangeEvent, useContext, useState } from "react";
import { SettingsOptionsContext } from "../SettingsOptions";
import { Stack, Switch, Typography } from "@mui/material";
import i18n from "translation";

interface SettingsSwitchProps {
  /**
   * Acts as the identifier of the settings option.
   */
  keyid: string;
  /**
   * Label to be displayed in the UI.
   */
  label: string;
  /**
   * When true, displays an "Off" and "On" label around the switch.
   */
  showLabels?: boolean;
  /**
   * The value of the Switch.
   */
  value: boolean;
}

export default function SettingsSwitch(props: SettingsSwitchProps): React.JSX.Element {
  const settingsOptions = useContext(SettingsOptionsContext);
  const [value, setValue] = useState<boolean>(props.value ?? true);

  return (
    <Stack direction="row" sx={{
      alignItems: "center"
    }}>
      <Typography sx={{ flex: 1 }}>{props.label}</Typography>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          flex: 0,
          mr: 0
        }}>
        {props.showLabels && <Typography>{i18n.t("off")}</Typography>}
        <Switch 
          checked={value}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            const newValue = event.target.checked;
            setValue(newValue);
            settingsOptions?.updateSettingsState(props.keyid, newValue);
          }}
        />
        {props.showLabels && <Typography>{i18n.t("on")}</Typography>}
      </Stack>
    </Stack>
  );
}